import { Pencil, RotateCcw } from "lucide-react";
import { Button, DefaultTooltip } from "twyne-new.ui";

export default function EditFormatter({ loading, data, isEditing, isDefault, onEdit, onDefault }) {
  const { id } = data

  const content = isDefault ? "Return to default" : "Edit"
  const color = isEditing ? "neutral" : "accent"
  const onClick = isDefault ? onDefault : () => onEdit(data)

  return <DefaultTooltip content={content} side="top">
    <Button id={`btn-view-${id}`} color={color} variant="outline" size="sm"
      disabled={isEditing || loading} onClick={onClick}>
      {isDefault ? <RotateCcw size={16} /> : <Pencil size={16} />}
    </Button>
  </DefaultTooltip>
}
